import { useQuery } from "@tanstack/react-query";

import api from "../apiClient";

import cookiesHelper from "../../helpers/cookies";

import { IPageViewsReportData } from "../../interfaces/analytics";

const useGetPageViewsReport = (filterQuery: string) => {
    const queryFn = async (): Promise<IPageViewsReportData> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`analytics/page-views-report?${filterQuery}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['page-views-report', filterQuery],
        queryFn,
        retry: 0,
    });
};

export default useGetPageViewsReport;